import * as V3 from '@optiaxiom/icons';
import * as V1 from '@optimizely/axiom-icons-v1';

// @optimizely/axiom-icons is aliased to this file (see rspack/tsconfig/vitest),
// so all callsites resolve through here unchanged. Most icons come from the v3
// package (@optiaxiom/icons); the v1 package only backfills glyphs and the
// `withIcon` HOC that v3 does not ship.
//
// The shared icons are sourced from v3 at runtime but typed against the v1
// surface (the public `@optimizely/axiom-icons` type contract callsites rely
// on, e.g. the `width`/`height` FA props). The names are identical across both.
const shared = V3 as unknown as typeof V1;

// Icons present in v3.
export const {
  Icon360Degrees,
  IconAgent,
  IconAlignCenter,
  IconAlignJustify,
  IconAlignLeft,
  IconAlignRight,
  IconAngleDown,
  IconAngleRight,
  IconAnglesUpDown,
  IconArrowDown,
  IconArrowDownAZ,
  IconArrowDownShortWide,
  IconArrowDownWideShort,
  IconArrowDownZA,
  IconArrowLeft,
  IconArrowLeftFromLine,
  IconArrowLeftLong,
  IconArrowLeftToLine,
  IconArrowRight,
  IconArrowRightArrowLeft,
  IconArrowRightFromBracket,
  IconArrowRightFromLine,
  IconArrowRightLong,
  IconArrowRightSolid,
  IconArrowRightToBracket,
  IconArrowRightToLine,
  IconArrowRotateLeft,
  IconArrowRotateRight,
  IconArrowTrendDown,
  IconArrowTrendUp,
  IconArrowTurnDownLeft,
  IconArrowTurnUp,
  IconArrowUp,
  IconArrowUpRightAndArrowDownLeftFromCenter,
  IconArrowUpRightFromSquare,
  IconArrowsFromDottedLine,
  IconArrowsFromLine,
  IconArrowsLeftRight,
  IconArrowsMaximize,
  IconArrowsMinimize,
  IconArrowsRepeat,
  IconArrowsRotate,
  IconArrowsUpDownLeftRight,
  IconAsterisk,
  IconAt,
  IconBadgePercent,
  IconBallPile,
  IconBan,
  IconBarcode,
  IconBars,
  IconBarsSort,
  IconBarsStaggered,
  IconBell,
  IconBellSlash,
  IconBold,
  IconBolt,
  IconBook,
  IconBookOpen,
  IconBookmarkSolid,
  IconBooks,
  IconBorderAll,
  IconBorderNone,
  IconBox,
  IconBoxArchive,
  IconBoxOpen,
  IconBoxesStacked,
  IconBracketsCurly,
  IconBracketsSquare,
  IconBrain,
  IconBriefcase,
  IconBrowser,
  IconBrowsers,
  IconBug,
  IconBullhorn,
  IconBullseyePointer,
  IconCalendar,
  IconCalendarClock,
  IconCalendarDays,
  IconCaretDownSolid,
  IconCaretUpSolid,
  IconCartCircleCheck,
  IconCartMinus,
  IconCartPlus,
  IconCartShopping,
  IconCartShoppingFast,
  IconChartColumn,
  IconChartLine,
  IconChartMixed,
  IconCheck,
  IconCheckCircleSolid,
  IconCheckDouble,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconCircle,
  IconCircleArrowDown,
  IconCircleArrowUp,
  IconCircleCheck,
  IconCircleCheckSolid,
  IconCircleChevronDown,
  IconCircleDollar,
  IconCircleDot,
  IconCircleExclamation,
  IconCircleHalfStrokeSolid,
  IconCircleInfo,
  IconCircleMinus,
  IconCirclePause,
  IconCirclePlay,
  IconCirclePlus,
  IconCircleQuestion,
  IconCircleSmallSolid,
  IconCircleSolid,
  IconCircleStop,
  IconCircleUser,
  IconCircleXmark,
  IconCircleXmarkSolid,
  IconClipboard,
  IconClipboardCheck,
  IconClock,
  IconClockRotateLeft,
  IconClone,
  IconCode,
  IconCodeBranch,
  IconColumns3,
  IconComment,
  IconCommentPlus,
  IconComments,
  IconCopy,
  IconCube,
  IconCubes,
  IconDatabase,
  IconDesktop,
  IconDiagramSubtask,
  IconDiagramVenn,
  IconDiamond,
  IconDisplay,
  IconDollarSign,
  IconDownload,
  IconDroplet,
  IconEllipsisSolid,
  IconEllipsisStroke,
  IconEllipsisStrokeVertical,
  IconEnvelope,
  IconEnvelopeOpen,
  IconEraser,
  IconExpand,
  IconEye,
  IconEyeSlash,
  IconFaceSmile,
  IconFile,
  IconFileArrowUp,
  IconFileChartPie,
  IconFileExclamation,
  IconFileExport,
  IconFileImage,
  IconFileImport,
  IconFileLines,
  IconFilePdf,
  IconFilePen,
  IconFilePlus,
  IconFileSpreadsheet,
  IconFileVideo,
  IconFileWord,
  IconFileZipper,
  IconFiles,
  IconFilter,
  IconFilterSlash,
  IconFlag,
  IconFlagPennant,
  IconFlask,
  IconFloppyDisk,
  IconFolder,
  IconFolderArrowDown,
  IconFolderBlank,
  IconFolderBookmark,
  IconFolderClosed,
  IconFolderImage,
  IconFolderOpen,
  IconFolderPlus,
  IconFolderTree,
  IconFolderUser,
  IconFolders,
  IconGalleryThumbnails,
  IconGauge,
  IconGear,
  IconGift,
  IconGlassesRound,
  IconGlobe,
  IconGrid,
  IconGrid2,
  IconGrid2Plus,
  IconGridDividers,
  IconGrip,
  IconGripLinesVertical,
  IconGripVertical,
  IconHandPointer,
  IconHashtag,
  IconHeading,
  IconHighlighter,
  IconHorizontalRule,
  IconHouse,
  IconHouseBlank,
  IconImage,
  IconImageLandscape,
  IconImagePortrait,
  IconImageSlash,
  IconImages,
  IconInboxFull,
  IconInputNumeric,
  IconInputPipe,
  IconInputText,
  IconItalic,
  IconKey,
  IconKeySkeletonLeftRight,
  IconLanguage,
  IconLaptopMobile,
  IconLayerGroup,
  IconLeftToLine,
  IconLightbulb,
  IconLineHeight,
  IconLink,
  IconLinkHorizontal,
  IconLinkHorizontalSlash,
  IconLinkSlash,
  IconList,
  IconListCheck,
  IconListDropdown,
  IconListOl,
  IconListTree,
  IconListUl,
  IconLocationDot,
  IconLock,
  IconLockOpen,
  IconMagnifyingGlass,
  IconMagnifyingGlassMinus,
  IconMagnifyingGlassPlus,
  IconMegaphone,
  IconMemoPad,
  IconMessageBot,
  IconMessageLines,
  IconMessages,
  IconMicrochipAi,
  IconMobile,
  IconMoneyBill,
  IconMoneyCheckPen,
  IconMonitorWaveform,
  IconMousePointer,
  IconMugHot,
  IconMusic,
  IconObjectsAlignBottom,
  IconObjectsAlignCenterVertical,
  IconObjectsAlignTop,
  IconOctagonMinus,
  IconPaintRoller,
  IconPanorama,
  IconPaperPlaneTop,
  IconPaperclip,
  IconPaste,
  IconPause,
  IconPen,
  IconPenField,
  IconPenLine,
  IconPenSlash,
  IconPenToSquare,
  IconPeopleSimple,
  IconPhone,
  IconPipe,
  IconPipeSection,
  IconPlay,
  IconPlus,
  IconPresentationScreen,
  IconPuzzlePiece,
  IconQuoteRight,
  IconRectangleList,
  IconRectangleWide,
  IconReply,
  IconRightFromLine,
  IconRobot,
  IconRocket,
  IconRss,
  IconScissors,
  IconScrewdriverWrench,
  IconSearch,
  IconServer,
  IconShapes,
  IconShareNodes,
  IconShieldCheck,
  IconShieldKeyhole,
  IconShip,
  IconSidebar,
  IconSitemap,
  IconSlider,
  IconSliders,
  IconSlidersSimple,
  IconSortSolid,
  IconSparkles,
  IconSpinner,
  IconSplit,
  IconSquare,
  IconSquareCheck,
  IconSquareDashed,
  IconSquarePlus,
  IconSquarePollHorizontal,
  IconSquareUser,
  IconStairs,
  IconStar,
  IconStore,
  IconStrikethrough,
  IconSubAgent,
  IconSubscript,
  IconSunBright,
  IconSuperscript,
  IconTableCells,
  IconTableLayout,
  IconTablet,
  IconTag,
  IconTerminal,
  IconText,
  IconThumbsDown,
  IconThumbsDownSolid,
  IconThumbsUp,
  IconThumbsUpSolid,
  IconThumbtack,
  IconThumbtackSolid,
  IconTimelineArrow,
  IconToggleOff,
  IconToolbox,
  IconTrashCan,
  IconTriangleExclamation,
  IconTruck,
  IconTruckMedical,
  IconUnderline,
  IconUpload,
  IconUser,
  IconUserCheck,
  IconUserGroup,
  IconUserLock,
  IconUserPen,
  IconUserPlus,
  IconUserRobot,
  IconUserSlash,
  IconUserXmark,
  IconUsers,
  IconVials,
  IconVideo,
  IconWavePulse,
  IconWebhook,
  IconWindowRestore,
  IconXmark,
} = shared;

// Glyphs only in the v1 package (brand/social glyphs, IconPopOut, …) — sourced
// from v1 so they never resolve to undefined.
export const {
  Icon00,
  IconBoxGear,
  IconDSolid,
  IconFacebookF,
  IconGoogle,
  IconHouzz,
  IconInstagram,
  IconLinkedinIn,
  IconPinterestP,
  IconPopOut,
  IconSnapchat,
  IconStrava,
  IconTSolid,
  IconTiktok,
  IconTumblr,
  IconTwitter,
  IconVimeoV,
  IconWeibo,
  IconWeixin,
  IconYoutube,
} = V1;

// v3 has no withIcon HOC (different glyph system); custom FA-path icons use v1.
export const withIcon = V1.withIcon;

export type * from '@optimizely/axiom-icons-v1';
